export default {
  wallmessage: (state) => state.wallmessage,
  wallmessages: (state) => state.wallmessages,
  mergeTags: (state) => state.mergeTags,
  cursorUrl: (state) => state.cursorUrl,
  workingText: (state) => state.workingText,
}
